import { TRIPROUTES_AGENT_CARDS } from "./triproutes-agents.mjs";
import { USER_AI_SOLUTION, userAISolutionHash } from "./triproutes-user-ai.mjs";
import { standaloneSolutions } from "./triproutes-standalone.mjs";
import { REFINEMENT_SOLUTION } from "./triproutes-refinements.mjs";
import {ROUTE_CHECK_SOLUTION,ROUTE_ANALYSIS_SOLUTION,CITY_CHECK_SOLUTION} from "./triproutes-route-checks.mjs";

export const TRIPROUTES_ADMIN_SOLUTIONS = [USER_AI_SOLUTION,
  { id: "city-routes", title: "Города и маршруты", description: "Исследование города, создание маршрутов и карточки города с проверкой и передачей в модерацию." },
  ...standaloneSolutions, REFINEMENT_SOLUTION, ROUTE_CHECK_SOLUTION, ROUTE_ANALYSIS_SOLUTION, CITY_CHECK_SOLUTION];

const composition = {
 "user-ai": ["user-ai-query_parse", "user-ai-idea_suggest", "user-ai-route_expand"],
 "city-routes": ["city-research", "route-ideas", "media-research", "route-assembly", "route-fact-check", "city-content"],
 "places-routes": ["bestplaces"], "cities": ["city-content"], "route-refinements": ["route-refinement-file"],
};
export function triproutesSolutionComposition(id) { return (composition[id] || []).map(id => TRIPROUTES_AGENT_CARDS.find(a => a.id === id)); }
export function triproutesSolutionSettingsHash(site = "ru", solution = "", tab = "solutions", resourceID = "", kind = "pipeline", state = "active") {
 const p = new URLSearchParams({site: site === "app" ? "app" : "ru", tab});
 if (["archived","all"].includes(state)) p.set("state",state);
 if (solution) p.set("solution",solution);
 if (resourceID) {p.set("resource",resourceID);p.set("kind",kind === "agent" ? "agent" : "pipeline");}
 return `#/settings/triproutes-solutions?${p}`;
}
export function triproutesSolutionSettingsRedirect(route) {
 if (route.section === "triproutes" && route.id === "solutions" && route.resourceID) return triproutesSolutionSettingsHash(route.site,"","draft",route.resourceID,route.authoringKind);
 if (route.section === "triproutes" && route.solution === "user-ai" && route.tab === "settings") return userAISolutionHash(route.site,"settings",route.userAISettingsParams || {});
 if (route.section !== "triproutes" || route.id !== "settings") return "";
 return triproutesSolutionSettingsHash(route.site,route.solutionId,route.tab === "legacy" ? "legacy" : "solutions");
}
export function triproutesSolutionRunHash(item,site) {
 if (item.lastLaunch?.taskId) return `#/tasks/${encodeURIComponent(item.lastLaunch.taskId)}?from=triproutes&site=${site}&list=runs`;
 if (item.id === "user-ai") return userAISolutionHash(site,"runs",{q:item.lastLaunch?.id,days:"36500"});
 const p = new URLSearchParams({site,solution:item.id});
 if (item.lastLaunch?.id) p.set("q",item.lastLaunch.id);
 return `#/triproutes/runs?${p}`;
}
export function triproutesSolutionSettingsStatus(item) {
 if (!item.enabled) return {tone:"off",label:"Выключено"};
 if (!item.version || !item.ready) return {tone:"warning",label:"Нужна настройка"};
 if (item.unpublished) return {tone:"warning",label:"Есть изменения"};
 return {tone:"ready",label:"Готово"};
}

// Retain the exact publication request after an uncertain response. A retry
// must not select newer drafts or allocate a second publication key.
export async function prepareTriproutesSolutionPublication(api,id,site,key) {
 if (id === "user-ai") {
  const data = await api.request("/v1/triproutes/ai-panel/profiles");
  return {path:"/v1/triproutes/ai-panel/publications", options:{method:"POST",headers:{"Idempotency-Key":key},body:{expectedRevisions:Object.fromEntries(data.profiles.map(p => [p.stage+":"+p.target,p.revision]))}}};
 }
 if (id === "route-refinements") {
  const report = await api.request(`/v1/triproutes/editors/validation/route_refinement_file?site=${site}`);
  if (!report.ready) throw new Error(report.blockers.map(b => b.message).join(" "));
  return {path:`/v1/triproutes/editors/publish/route_refinement_file?site=${site}`,options:{method:"POST",headers:{"Idempotency-Key":key},body:{contractDigest:report.contractDigest}}};
 }
 if (!["city-routes","places-routes","cities"].includes(id)) throw new Error("Неизвестное решение");
 const build = await api.request(`/v1/triproutes/build-revision?site=${site}`);
 return {path:`/v1/triproutes/city-routes/publish?site=${site}&solution=${id}`,options:{method:"POST",headers:{"X-AI-Build-Expected-Revision":String(build.revision),"Idempotency-Key":key},body:{}}};
}
